import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = {
  class: "dialog_content",
  style: {"overflow":"hidden"}
}
const _hoisted_4 = { class: "field-group" }
const _hoisted_5 = { class: "field-group__row no-wrap justify-left q-my-xs" }
const _hoisted_6 = { class: "field-group q-mt-sm" }
const _hoisted_7 = {
  class: "row no-wrap",
  style: {"align-items":"baseline"}
}
const _hoisted_8 = {
  class: "dnd-table-tabs",
  style: {"max-height":"calc(100% - 46px)","height":"calc(100% - 46px)","min-height":"calc(100% - 46px)"}
}
const _hoisted_9 = {
  class: "tab-headers",
  ref: "tabheaders"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "row no-wrap display-buttons-on-hover",
  style: {"align-items":"start"}
}
const _hoisted_12 = {
  class: "q-ml-xs",
  style: {"font-size":"14px","margin-top":"3px"}
}
const _hoisted_13 = { class: "q-ml-sm" }
const _hoisted_14 = { class: "tab-content" }
const _hoisted_15 = { class: "dialog-table" }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "row no-wrap" }
const _hoisted_21 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_drop_zone = _resolveComponent("drop-zone")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_storage_info_component = _resolveComponent("storage-info-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_drag_row = _resolveComponent("drag-row")!
  const _component_dnd_provider = _resolveComponent("dnd-provider")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('edit_warehouses_full')), 1),
        _createVNode(_component_app_icon, {
          name: "close",
          width: "18px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              style: {"text-decoration":"underline"},
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addStorage && _ctx.addStorage(...args)))
            }, " + " + _toDisplayString(_ctx.$t('warehouse')), 1),
            _createElementVNode("div", {
              style: {"text-decoration":"underline"},
              class: "cursor-pointer q-ml-xl",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addStorageGroup && _ctx.addStorageGroup(...args)))
            }, " + " + _toDisplayString(_ctx.$t('warehouse_group')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              ref: "header_search_input",
              color: "white",
              class: "thin-input q-my-auto",
              style: {"min-width":"400px","margin-left":"-5px"},
              modelValue: _ctx.search_filter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search_filter) = $event)),
              "hide-bottom-space": "",
              clearable: "",
              "clear-icon": "arrow_back",
              placeholder: _ctx.$t('search_label'),
              debounce: "300",
              onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search_filter = ''))
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_q_icon, {
              color: "accent",
              size: "sm",
              name: "search"
            })
          ])
        ]),
        _createVNode(_component_dnd_provider, {
          backend: _ctx.HTML5Backend,
          context: _ctx._WINDOW_
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, tab_idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tab.id,
                    class: _normalizeClass(['tab-header', { active: _ctx.activeTab === tab.id }]),
                    onClick: _withModifiers(($event: any) => (_ctx.activeTab = tab.id), ["stop"])
                  }, [
                    _createVNode(_component_drop_zone, {
                      "target-id": tab.id,
                      onMoveRow: _ctx.moveRow
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_native_input, {
                            ref_for: true,
                            ref: (el) => { _ctx.inputs[tab_idx] = el },
                            "model-value": tab.label,
                            "allow-line-break": false,
                            "onUpdate:modelValue": 
                      (newname) => {
                        if (tab.label != newname) {
                          _ctx.onRenameGroup(tab.dbId, newname);
                        }
                      }
                    
                          }, null, 8, ["model-value", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_12, "(" + _toDisplayString(tab.rows_count) + ")", 1),
                          (tab.dbId > 0)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                flat: "",
                                dense: "",
                                round: "",
                                size: "9px",
                                class: "q-ml-xs",
                                onClick: _withModifiers(($event: any) => (_ctx.focusInput(tab_idx)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_app_icon, {
                                    name: "edit-pencil",
                                    width: "18px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (tab.dbId > 0)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 1,
                                flat: "",
                                dense: "",
                                round: "",
                                size: "9px",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_app_icon, {
                                    name: "delete-outline",
                                    width: "18px",
                                    color: "#979797",
                                    "hover-color": "#D05A4F",
                                    cursor: "pointer"
                                  }),
                                  _createVNode(_component_q_menu, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_card, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_card_section, { class: "row items-center" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_app_icon, {
                                                name: "delete-outline",
                                                width: "18px",
                                                color: "#979797"
                                              }),
                                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("sure_delete")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_card_actions, { align: "right" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                size: "sm",
                                                flat: "",
                                                label: _ctx.$t('cancel'),
                                                color: "dark",
                                                ref_for: true,
                                                ref: 'cancelbtn'
                                              }, null, 8, ["label"]), [
                                                [_directive_close_popup]
                                              ]),
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                size: "sm",
                                                flat: "",
                                                label: _ctx.$t('remove'),
                                                autofocus: "",
                                                color: "dark",
                                                ref_for: true,
                                                ref: 'okbtn',
                                                onClick: ($event: any) => (_ctx.onDeleteGroup(tab.dbId))
                                              }, null, 8, ["label", "onClick"]), [
                                                [_directive_close_popup]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["target-id", "onMoveRow"])
                  ], 10, _hoisted_10))
                }), 128))
              ], 512),
              _createElementVNode("div", {
                class: "inner_container",
                style: _normalizeStyle(`overflow: auto; height: calc(100% - ${46+(this.$refs.tabheaders ? this.$refs.tabheaders.offsetHeight : 0)}px)`)
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("table", _hoisted_15, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('warehouse_name')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('qty_units')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('amount')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('responsible_worker')), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRows.filter(r => 
                    (r.header_row && _ctx.currentRows.filter(rm => !rm.header_row && rm.group_id === r.group_id && rm.name.toLowerCase().includes(this.search_filter.toLowerCase() || '')).length)
                    || !r.header_row && r.name.toLowerCase().includes(this.search_filter.toLowerCase() || '')), (row, row_index) => {
                        return (_openBlock(), _createBlock(_component_drag_row, {
                          class: "display-buttons-on-hover",
                          key: 'storage_' + row_index,
                          row: row,
                          "source-id": _ctx.activeTab,
                          onClick: _withModifiers(($event: any) => (!row.header_row && (row.showInfoDialog = true)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("td", {
                              style: _normalizeStyle(
                        row.header_row ? ' border-top: 0; padding: 16px;' : ''
                      )
                            }, _toDisplayString(!row.header_row ? row.idx + "." : "") + " " + _toDisplayString(row.name), 5),
                            _createElementVNode("td", {
                              colspan: row.header_row ? 4 : 1,
                              style: _normalizeStyle(
                        row.header_row ? 'border-left: 0; border-top: 0;' : ''
                      )
                            }, _toDisplayString(!row.header_row ? row.qty : ""), 13, _hoisted_16),
                            (!row.header_row)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(row.sum), 1))
                              : _createCommentVNode("", true),
                            (!row.header_row)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(row.responsible), 1))
                              : _createCommentVNode("", true),
                            (!row.header_row)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      round: "",
                                      size: "10px",
                                      onClick: _withModifiers(($event: any) => (row.showInfoDialog = true), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_app_icon, {
                                          name: "edit-pencil",
                                          width: "18px",
                                          color: "#979797",
                                          "hover-color": "#499259",
                                          cursor: "pointer"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      disable: Number(row.qty) > 0,
                                      flat: "",
                                      dense: "",
                                      round: "",
                                      size: "10px",
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_app_icon, {
                                          name: "delete-outline",
                                          width: "18px",
                                          color: "#979797",
                                          "hover-color": "#D05A4F",
                                          cursor: "pointer"
                                        }),
                                        (row.qty > 0)
                                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                              key: 0,
                                              delay: 300,
                                              anchor: "top middle",
                                              self: "center middle"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('cannot_delete_warehouse_with_goods')), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (Number(row.qty) <= 0)
                                          ? (_openBlock(), _createBlock(_component_q_menu, { key: 1 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_card, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_card_section, { class: "row items-center" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_app_icon, {
                                                          name: "delete-outline",
                                                          width: "18px",
                                                          color: "#979797"
                                                        }),
                                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("sure_delete")), 1)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_q_card_actions, { align: "right" }, {
                                                      default: _withCtx(() => [
                                                        _withDirectives(_createVNode(_component_q_btn, {
                                                          size: "sm",
                                                          flat: "",
                                                          label: _ctx.$t('cancel'),
                                                          color: "dark",
                                                          ref_for: true,
                                                          ref: 'cancelbtn'
                                                        }, null, 8, ["label"]), [
                                                          [_directive_close_popup]
                                                        ]),
                                                        _withDirectives(_createVNode(_component_q_btn, {
                                                          size: "sm",
                                                          flat: "",
                                                          label: _ctx.$t('remove'),
                                                          autofocus: "",
                                                          color: "dark",
                                                          ref_for: true,
                                                          ref: 'okbtn',
                                                          onClick: ($event: any) => (_ctx.removeStorage(row.id))
                                                        }, null, 8, ["label", "onClick"]), [
                                                          [_directive_close_popup]
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["disable"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_q_dialog, {
                              modelValue: row.showInfoDialog,
                              "onUpdate:modelValue": ($event: any) => ((row.showInfoDialog) = $event),
                              "full-width": false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_storage_info_component, {
                                  "current-storage": row.source_storage,
                                  "storage-group-id": row.current_group_id,
                                  "edit-name-on-start": row.openNameEditing,
                                  onClose: ($event: any) => (row.showInfoDialog = false)
                                }, null, 8, ["current-storage", "storage-group-id", "edit-name-on-start", "onClose"])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["row", "source-id", "onClick"]))
                      }), 128))
                    ])
                  ])
                ])
              ], 4)
            ])
          ]),
          _: 1
        }, 8, ["backend", "context"])
      ])
    ]),
    _: 1
  }))
}